import React from 'react';

const Button = function({text,disabled,click,...props}) {
    return (
      <button disabled={disabled ? true : false} onClick={click} className="btn">{text}</button>
    );
}
export default Button;
